import { render, staticRenderFns } from "./LogoRutifyLetter.vue?vue&type=template&id=3495eb81&"
import script from "./LogoRutifyLetter.vue?vue&type=script&lang=js&"
export * from "./LogoRutifyLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports